import { useEffect } from 'react';
import { RouterProvider } from 'react-router';
import { MotionConfig } from 'motion/react';
import { router, prefetchRoutes } from './routes';
import { AuthProvider } from '../contexts/AuthContext';
import { SettingsProvider } from '../contexts/SettingsContext';
import { SmoothScroll } from '../lib/animation/SmoothScroll';

export default function App() {
  // Warm every screen's code once the first page has painted, so navigation is instant.
  useEffect(() => {
    const idle = window.requestIdleCallback ?? ((cb: () => void) => window.setTimeout(cb, 1500));
    const handle = idle(() => prefetchRoutes());
    return () => {
      if (window.cancelIdleCallback) window.cancelIdleCallback(handle as number);
    };
  }, []);

  return (
    // reducedMotion="user": every Motion animation honours the OS "reduce motion" setting.
    <MotionConfig reducedMotion="user">
      <SmoothScroll>
        <SettingsProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </SettingsProvider>
      </SmoothScroll>
    </MotionConfig>
  );
}
